import { useIdentity } from '@office-start/identity-service';
import { PageUnstyled } from '@office-start/office-home-app-shared';
import React from 'react';
export var CopilotPage = function () {
    var sandBoxProperties = 'allow-forms allow-popups allow-popups-to-escape-sandbox allow-pointer-lock allow-scripts allow-same-origin allow-modals allow-downloads allow-top-navigation allow-storage-access-by-user-activation';
    var identity = useIdentity().data;
    var url = 'https://www.bing.com/copilot?hostnameOvr=copilot';
    if (!identity) {
        return null;
    }
    return (React.createElement(PageUnstyled, { name: "CopilotCmc" },
        React.createElement("div", { style: { height: '100%', overflow: 'hidden' } },
            React.createElement("iframe", { "data-tid": "cmc-host-iframe", sandbox: sandBoxProperties, title: "Copilot", src: url, allow: "microphone; camera", style: { width: '100%', height: '100%' } }))));
};
//# sourceMappingURL=CopilotPage.js.map